import * as React from 'react';
import styled from 'styled-components';
import MuiButtonGroup, { ButtonGroupProps as MuiButtonGroupProps } from '@material-ui/core/ButtonGroup';

const StyledButton = styled(MuiButtonGroup)``;

export type DSButtonGroupProps = Omit<MuiButtonGroupProps, 'component'>;
export const DSButtonGroup: React.FC<DSButtonGroupProps> = props => <StyledButton {...props} />;
DSButtonGroup.displayName = 'DSButtonGroup';
